<template>
  <div class="com-home-banner">

  </div>
</template>

<script>
  /**
   * @Class: components
   * @Module: com-home-banner.vue
   * @Description: 组件 -首页 -banner
   * @Version: 1.0.0
   ---- Created by "Sitdown.liu<731225377@qq.com>" on "2020/4/29 14:44" ---*/
  export default {
    props: ["img"],
    name: "com-home-banner"
  }
</script>

<style lang="less">
  .com-home-banner {
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/com-home-banner.vue